// extracted by mini-css-extract-plugin
module.exports = {"message":"_BasicFieldError__message--v-5KR"};